import * as z from 'zod';

import { Theme } from '#packages/web/theme';

export const ThemeSettingsSchema = z.object({
  /**
   * The name of the application theme.
   */
  name: z.enum(Theme.availableThemes).prefault('green'),

  /**
   * The appearance mode of the application.
   */
  appearance: z.enum(['light', 'dark', 'system']).prefault('system'),
});

export type ThemeSettings = z.infer<typeof ThemeSettingsSchema>;
export type ThemeName = ThemeSettings['name'];
export type ThemeAppearance = ThemeSettings['appearance'];

export const AutoUpdateSettingsSchema = z.object({
  /**
   * Whether auto-updates are enabled or not.
   */
  enabled: z.boolean().prefault(true),
});

export type AutoUpdateSettings = z.infer<typeof AutoUpdateSettingsSchema>;

export const FormsSettingsSchema = z.object({
  showFieldDescriptions: z.boolean().prefault(true),
});

export type FormsSettings = z.infer<typeof FormsSettingsSchema>;

export const AppSettingsSchema = z.object({
  /**
   * The theme settings of the application.
   */
  theme: ThemeSettingsSchema.prefault({}),

  /**
   * The auto-update settings of the application.
   */
  autoUpdate: AutoUpdateSettingsSchema.prefault({}),

  /**
   * The forms settings of the application.
   */
  forms: FormsSettingsSchema.prefault({}),
});

export type AppSettings = z.infer<typeof AppSettingsSchema>;
